(function () {
  if (window.__dtGokwikCheckoutRuntimeLoaded) return;
  window.__dtGokwikCheckoutRuntimeLoaded = true;

  var CHECKOUT_SELECTOR = '[data-dt-gokwik-checkout], .gokwik-checkout .cart-drawer__checkout-btn';
  var CHECKOUT_WAIT_MS = 12000;
  var CHECKOUT_RETRIGGER_WAIT_MS = 8000;
  var CHECKOUT_MAX_WAIT_MS = 20000;
  var CHECKOUT_PROGRESS_MS = 4000;
  var CHECKOUT_POLL_MS = 100;
  var CART_CACHE_MS = 1500;
  var CART_READ_ATTEMPTS = 3;
  var BUNDLE_ADD_SETTLE_MS = 900;
  var BUNDLE_ADD_INTENT_MS = 9000;
  var PROGRESS_TEXT = 'Still connecting to secure checkout…';
  var STATE_TEXT = {
    syncing: 'Updating cart…',
    opening: 'Opening secure checkout…',
    opened: 'Checkout opened',
    retry: 'Try checkout again'
  };
  var STATE_STATUS = {
    syncing: 'Updating your cart before checkout.',
    opening: 'Opening secure checkout.',
    opened: 'Secure checkout opened.'
  };
  var checkoutState = 'booting';
  var activeAttempt = 0;
  var lastCheckoutButton = null;
  var cachedCart = null;
  var cachedCartAt = 0;
  var cartReadPromise = null;
  var cartCacheVersion = 0;
  var cartPreparationTasks = {};
  var bundleCartActivity = { inflight: 0, lastAddAt: 0, intentAt: 0, addSeenSinceIntent: false };

  function getCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = [];

    if (scope.matches && scope.matches(CHECKOUT_SELECTOR)) buttons.push(scope);
    Array.prototype.push.apply(buttons, scope.querySelectorAll(CHECKOUT_SELECTOR));
    return buttons;
  }

  function getStatus(button) {
    var container = button && button.closest ? button.closest('.gokwik-checkout') : null;
    return container ? container.querySelector('[data-dt-gokwik-checkout-status]') : null;
  }

  function setStatus(button, message) {
    var status = getStatus(button);
    if (status) status.textContent = message || '';
  }

  function ensureNoticeStyles() {
    if (document.getElementById('dt-gokwik-checkout-notice-style')) return;
    var style = document.createElement('style');
    style.id = 'dt-gokwik-checkout-notice-style';
    style.textContent = '.dt-gokwik-checkout-notice{margin:8px 0 0;font-size:13px;line-height:1.4;font-weight:500;text-align:center;color:#b42318}';
    document.head.appendChild(style);
  }

  // Visible inline error under the checkout button (the status element is screen-reader only).
  function showCheckoutFailure(button, message) {
    var container = button && button.closest ? button.closest('.gokwik-checkout') : null;
    if (!container || !container.parentNode) return;
    ensureNoticeStyles();

    var notice = container.parentNode.querySelector('[data-dt-gokwik-checkout-notice]');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'dt-gokwik-checkout-notice';
      notice.setAttribute('data-dt-gokwik-checkout-notice', '');
      notice.setAttribute('role', 'alert');
      container.insertAdjacentElement('afterend', notice);
    }
    notice.textContent = message;
    notice.hidden = false;
  }

  function hideCheckoutFailures() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dt-gokwik-checkout-notice]'), function (element) {
      element.hidden = true;
    });
  }

  function setButtonState(button, state, statusMessage) {
    if (!button) return;

    var label = button.querySelector('.btn-text');
    var isBusy = state === 'syncing' || state === 'opening';
    var isDisabled = state === 'booting' || isBusy || state === 'opened';

    if (label) {
      label.dataset.readyText = label.dataset.readyText || label.textContent.trim() || 'Proceed to Checkout';
      label.textContent = STATE_TEXT[state] || label.dataset.readyText;
    }

    button.setAttribute('data-dt-gokwik-checkout', '');
    button.dataset.checkoutState = state;
    button.dataset.checkoutPending = isBusy ? 'true' : 'false';
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    button.classList.toggle('dt-gokwik-waiting', isBusy);
    button.classList.toggle('disabled', isBusy || state === 'opened');
    button.disabled = isDisabled;
    button.removeAttribute('onclick');
    setStatus(button, statusMessage === undefined ? STATE_STATUS[state] : statusMessage);
  }

  function setCheckoutState(state, statusMessage) {
    checkoutState = state;
    if (state !== 'retry') hideCheckoutFailures();
    getCheckoutButtons(document).forEach(function (button) {
      setButtonState(button, state, statusMessage);
    });
  }

  function initializeCheckoutButtons(root) {
    getCheckoutButtons(root).forEach(function (button) {
      setButtonState(button, checkoutState);
    });
  }

  function setRetryState(message) {
    var retryMessage = message || 'Checkout could not open. Please try again.';
    setCheckoutState('retry', retryMessage);
    if (lastCheckoutButton && lastCheckoutButton.isConnected) {
      showCheckoutFailure(lastCheckoutButton, retryMessage);
    }
  }

  function getVisibleGokwikFrame() {
    var frames = document.querySelectorAll('#gokwik-iframe, iframe[src*="pdp.gokwik.co/index"], iframe[src*="gokwik.co/index"]');

    return Array.prototype.find.call(frames, function (frame) {
      var rect = frame.getBoundingClientRect();
      var style = window.getComputedStyle(frame);
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    }) || null;
  }

  function waitForVisibleGokwikFrame(attemptId, maxWaitMs) {
    return new Promise(function (resolve) {
      var startedAt = Date.now();
      var waitMs = maxWaitMs || CHECKOUT_WAIT_MS;

      function check() {
        if (attemptId !== activeAttempt) {
          resolve(null);
          return;
        }

        var frame = getVisibleGokwikFrame();
        if (frame) {
          resolve(frame);
          return;
        }

        if (Date.now() - startedAt >= waitMs) {
          resolve(null);
          return;
        }

        window.setTimeout(check, CHECKOUT_POLL_MS);
      }

      check();
    });
  }

  function getCheckoutFeedback() {
    if (window.dtGokwikCheckoutFeedback && typeof window.dtGokwikCheckoutFeedback.begin === 'function') {
      return window.dtGokwikCheckoutFeedback;
    }

    var overlay = null;
    var hideTimer = null;
    var visibleStartedAt = 0;
    var minVisibleMs = 350;

    function ensureOverlay() {
      if (overlay && overlay.isConnected) return overlay;

      overlay = document.createElement('div');
      overlay.className = 'dt-gokwik-glass-overlay';
      overlay.setAttribute('aria-hidden', 'true');

      var panel = document.createElement('div');
      panel.className = 'dt-gokwik-glass-overlay__panel';

      var spinner = document.createElement('span');
      spinner.className = 'dt-gokwik-glass-overlay__spinner';
      spinner.setAttribute('aria-hidden', 'true');

      var message = document.createElement('span');
      message.className = 'dt-gokwik-glass-overlay__text';

      panel.appendChild(spinner);
      panel.appendChild(message);
      overlay.appendChild(panel);
      document.body.appendChild(overlay);
      return overlay;
    }

    function update(message) {
      var activeOverlay = ensureOverlay();
      var messageElement = activeOverlay.querySelector('.dt-gokwik-glass-overlay__text');
      if (messageElement) messageElement.textContent = message || 'Opening secure checkout…';
    }

    function begin(message) {
      if (getVisibleGokwikFrame()) return;
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = null;
      visibleStartedAt = Date.now();
      update(message);
      ensureOverlay().classList.add('is-visible');
    }

    function hide() {
      if (!overlay || !overlay.isConnected) return;
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        hideTimer = null;
        if (!overlay || !overlay.isConnected) return;
        overlay.classList.remove('is-visible');
        window.setTimeout(function () {
          if (overlay && overlay.isConnected && !overlay.classList.contains('is-visible')) overlay.remove();
        }, 180);
      }, Math.max(0, minVisibleMs - (Date.now() - visibleStartedAt)));
    }

    window.dtGokwikCheckoutFeedback = { begin: begin, update: update, hide: hide };
    return window.dtGokwikCheckoutFeedback;
  }

  function wakeGoKwik() {
    if (typeof window.dtLoadGoKwik === 'function') window.dtLoadGoKwik();

    try {
      document.dispatchEvent(new CustomEvent('initGKJS'));
    } catch (eventError) {
      var initEvent = document.createEvent('Event');
      initEvent.initEvent('initGKJS', true, true);
      document.dispatchEvent(initEvent);
    }

    try {
      if (window.gokwikSdk && typeof window.gokwikSdk.init === 'function') window.gokwikSdk.init();
    } catch (initError) {
      console.warn('[GoKwik] Retry initialization failed.', initError);
    }
  }

  function getCheckoutStarter() {
    if (typeof window.triggerGokwikCustomCheckout === 'function') {
      return function () {
        window.triggerGokwikCustomCheckout();
      };
    }

    if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') {
      return function () {
        window.gokwikSdk.initCheckout(window.merchantInfo || {});
      };
    }

    if (typeof window.onCheckoutClick === 'function') {
      return function () {
        var proxyButton = document.createElement('button');
        proxyButton.appendChild(document.createElement('span'));
        window.onCheckoutClick(proxyButton);
      };
    }

    return null;
  }

  function waitForCheckoutStarter(attemptId) {
    return new Promise(function (resolve) {
      var startedAt = Date.now();

      function cleanup() {
        window.removeEventListener('gokwikLoaded', check);
      }

      function check() {
        if (attemptId !== activeAttempt) {
          cleanup();
          resolve(null);
          return;
        }

        var starter = getCheckoutStarter();
        if (starter) {
          cleanup();
          resolve(starter);
          return;
        }

        if (Date.now() - startedAt >= CHECKOUT_WAIT_MS) {
          cleanup();
          resolve(null);
          return;
        }

        window.setTimeout(check, CHECKOUT_POLL_MS);
      }

      window.addEventListener('gokwikLoaded', check);
      check();
    });
  }

  function isOptimisticCart(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      return String(item && item.key || '').indexOf('dt-easybundle-optimistic') === 0 ||
        Boolean(item && item.properties && item.properties._dt_bundle_instance === 'optimistic');
    }));
  }

  async function readCart() {
    if (cachedCart && isOptimisticCart(cachedCart)) cachedCart = null;
    if (cachedCart && Date.now() - cachedCartAt < CART_CACHE_MS) return cachedCart;
    if (cartReadPromise) return cartReadPromise;

    var readVersion = cartCacheVersion;
    var requestPromise = (async function () {
      try {
        var response = await fetch('/cart.js', { credentials: 'same-origin' });
        var cart = response.ok ? await response.json() : null;
        if (readVersion !== cartCacheVersion) return null;
        cachedCart = cart;
        cachedCartAt = cachedCart ? Date.now() : 0;
        return cachedCart;
      } catch (error) {
        console.warn('[GoKwik] Unable to read cart before checkout', error);
        return null;
      } finally {
        if (cartReadPromise === requestPromise) cartReadPromise = null;
      }
    })();
    cartReadPromise = requestPromise;
    return cartReadPromise;
  }

  // readCart returns null when a cart:updated invalidation lands mid-request; read again instead of failing the tap.
  async function readConfirmedCart(attemptId) {
    for (var attempt = 0; attempt < CART_READ_ATTEMPTS; attempt += 1) {
      if (attemptId !== activeAttempt) return null;
      var cart = await readCart();
      if (cart) return cart;
      await new Promise(function (resolve) { window.setTimeout(resolve, 150); });
    }
    return null;
  }

  function invalidateCartCache() {
    cartCacheVersion += 1;
    cachedCart = null;
    cachedCartAt = 0;
    cartReadPromise = null;
  }

  function hasPendingCartMutations() {
    return Boolean(
      window.CartController &&
      typeof window.CartController.flushPendingCartMutations === 'function' &&
      (
        (window.CartController.pendingRemovalKeys && window.CartController.pendingRemovalKeys.size) ||
        (window.CartController.pendingQuantityUpdates && window.CartController.pendingQuantityUpdates.size) ||
        window.CartController.pendingQuantityPromise ||
        (window.CartController.pendingAddQueue && window.CartController.pendingAddQueue.length) ||
        window.CartController.pendingAddPromise
      )
    );
  }

  function isBundleAppCartMutation(url) {
    url = String(url || '');
    return url.indexOf('gbbSdkBundleApp') !== -1 && url.indexOf('/cart/add') !== -1;
  }

  function beginBundleCartRequest() {
    bundleCartActivity.inflight += 1;
  }

  function endBundleCartRequest() {
    bundleCartActivity.inflight = Math.max(0, bundleCartActivity.inflight - 1);
    bundleCartActivity.lastAddAt = Date.now();
    bundleCartActivity.addSeenSinceIntent = true;
  }

  // Easy Bundle (gbb) writes the bundle with its own /cart/add.js?app=gbbSdkBundleApp calls, outside CartController.
  function observeBundleCartRequests() {
    if (window.fetch && !window.fetch.__dtGokwikBundleObserved) {
      var originalFetch = window.fetch;
      var observedFetch = function (resource, init) {
        var url = typeof resource === 'string' ? resource : resource && resource.url;
        var request = originalFetch.apply(this, arguments);
        if (isBundleAppCartMutation(url)) {
          beginBundleCartRequest();
          Promise.resolve(request).then(endBundleCartRequest, endBundleCartRequest);
        }
        return request;
      };
      Object.keys(originalFetch).forEach(function (key) {
        observedFetch[key] = originalFetch[key];
      });
      observedFetch.__dtGokwikBundleObserved = true;
      window.fetch = observedFetch;
    }

    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__dtGokwikBundleObserved) {
      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__dtGokwikBundleUrl = isBundleAppCartMutation(url) ? String(url) : '';
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var url = this.__dtGokwikBundleUrl;
        if (url) {
          beginBundleCartRequest();
          this.addEventListener('loadend', endBundleCartRequest, { once: true });
        }
        return originalSend.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__dtGokwikBundleObserved = true;
    }
  }

  function isBundleAddControl(target) {
    var control = target && target.closest ? target.closest('.gbbFooterNextButton, .gbbAddToCartButton') : null;
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return false;
    return /add\s*to\s*cart/i.test(control.textContent || '');
  }

  // Only Easy Bundle adds count: a gbb /cart/add.js in flight, a bundle Add To Cart tapped whose add has not
  // started yet, or a gbb add that finished moments ago (the app sends its adds back to back).
  // Pages without an Easy Bundle add never wait here.
  function isBundleCartSettling() {
    var now = Date.now();
    if (bundleCartActivity.inflight > 0) return true;
    if (bundleCartActivity.intentAt && now - bundleCartActivity.intentAt < BUNDLE_ADD_INTENT_MS && !bundleCartActivity.addSeenSinceIntent) return true;
    return Boolean(bundleCartActivity.lastAddAt && now - bundleCartActivity.lastAddAt < BUNDLE_ADD_SETTLE_MS);
  }

  function waitForBundleCartToSettle(attemptId) {
    return new Promise(function (resolve) {
      function check() {
        if (attemptId !== activeAttempt || !isBundleCartSettling()) {
          resolve(attemptId === activeAttempt);
          return;
        }
        window.setTimeout(check, CHECKOUT_POLL_MS);
      }
      check();
    });
  }

  function runCartPreparationTask(name, task) {
    if (cartPreparationTasks[name]) return cartPreparationTasks[name];
    var promise = Promise.resolve().then(task).finally(function () {
      if (cartPreparationTasks[name] === promise) delete cartPreparationTasks[name];
    });
    cartPreparationTasks[name] = promise;
    return promise;
  }

  async function prepareStandardCheckoutCart(cart, attemptId) {
    var pendingTasks = Object.keys(cartPreparationTasks).map(function (name) {
      return cartPreparationTasks[name];
    });
    if (pendingTasks.length) {
      await Promise.all(pendingTasks);
      if (attemptId !== activeAttempt) return;
      invalidateCartCache();
      cart = await readConfirmedCart(attemptId);
      if (attemptId !== activeAttempt) return;
      if (!cart) throw new Error('Unable to confirm the current cart.');
    }
    if (typeof window.dtReconcileFreebieCart === 'function') {
      cart = await runCartPreparationTask('gift', function () {
        return window.dtReconcileFreebieCart(cart);
      });
    }
    if (attemptId !== activeAttempt) return;

    if (typeof window.dtClearByobOnlyDiscountArtifacts === 'function') {
      window.dtClearByobOnlyDiscountArtifacts({ cart: cart });
    }

    if (
      typeof window.dtCartHasByobOnlyDiscount === 'function' &&
      typeof window.dtClearByobOnlyShopifyDiscount === 'function' &&
      window.dtCartHasByobOnlyDiscount(cart)
    ) {
      await runCartPreparationTask('discount', function () {
        return window.dtClearByobOnlyShopifyDiscount(cart, { allowByob: false, force: true });
      });
      if (attemptId !== activeAttempt) return;
      invalidateCartCache();
      cart = await readConfirmedCart(attemptId);
    }
    if (attemptId !== activeAttempt) return;
    if (!cart) throw new Error('Unable to confirm the current cart.');

    if (cart && typeof window.dtSyncGokwikTierDiscount === 'function') {
      window.dtSyncGokwikTierDiscount(cart);
    }
    if (typeof window.dtPrepareGokwikEasyBundleCart === 'function') {
      await runCartPreparationTask('bundle', function () {
        return window.dtPrepareGokwikEasyBundleCart(cart);
      });
    }
  }

  function warmCheckout(event) {
    var cart = event && event.detail;

    initializeCheckoutButtons(document);
    if (!cart || !Array.isArray(cart.items)) cart = window.CartController && window.CartController.cart;
    if (!cart || !Array.isArray(cart.items)) cart = window.gokwikCart;

    if (cart && Array.isArray(cart.items) && !isOptimisticCart(cart)) {
      cachedCart = cart;
      cachedCartAt = Date.now();
    } else {
      readCart();
    }

    wakeGoKwik();
  }

  function focusCheckoutFrame(frame) {
    if (!frame || typeof frame.focus !== 'function') return;
    if (!frame.getAttribute('title')) frame.setAttribute('title', 'Secure checkout');
    try {
      frame.focus({ preventScroll: true });
    } catch (error) {
      frame.focus();
    }
  }

  function bindModalClose() {
    if (window.__dtGokwikModalCloseBound) return;
    if (!window.gokwikSdk || typeof window.gokwikSdk.on !== 'function') return;

    window.__dtGokwikModalCloseBound = true;
    window.gokwikSdk.on('modal_closed', function () {
      activeAttempt += 1;
      getCheckoutFeedback().hide();
      setCheckoutState('ready', '');
      if (lastCheckoutButton && lastCheckoutButton.isConnected && lastCheckoutButton.offsetParent !== null) {
        lastCheckoutButton.focus();
      }
    });
  }

  window.dtGokwikCheckoutClick = async function (button) {
    if (!button || checkoutState === 'syncing' || checkoutState === 'opening' || checkoutState === 'opened') return;

    var existingFrame = getVisibleGokwikFrame();
    if (existingFrame) {
      setCheckoutState('opened');
      getCheckoutFeedback().hide();
      focusCheckoutFrame(existingFrame);
      return;
    }

    var attemptId = ++activeAttempt;
    var checkoutFeedback = getCheckoutFeedback();
    var bundleCartSettling = isBundleCartSettling();
    var pendingCartMutations = hasPendingCartMutations();
    var isSyncing = pendingCartMutations || bundleCartSettling;
    lastCheckoutButton = button;

    setCheckoutState(isSyncing ? 'syncing' : 'opening');
    checkoutFeedback.begin(isSyncing ? 'Updating your cart…' : 'Opening secure checkout…');

    var attemptStartedAt = Date.now();
    var deadlineTimer;
    var rejectDeadline;
    var deadline = new Promise(function (resolve, reject) {
      rejectDeadline = reject;
    });
    deadline.catch(function () {});
    function armDeadline(ms) {
      window.clearTimeout(deadlineTimer);
      deadlineTimer = window.setTimeout(function () {
        var error = new Error('Checkout preparation timed out.');
        error.checkoutTimedOut = true;
        rejectDeadline(error);
      }, ms);
    }
    armDeadline(CHECKOUT_WAIT_MS);
    function waitForStep(promise) {
      return Promise.race([promise, deadline]);
    }

    var progressTimer = window.setTimeout(function () {
      if (attemptId !== activeAttempt || getVisibleGokwikFrame()) return;
      checkoutFeedback.update(PROGRESS_TEXT);
      setStatus(button, PROGRESS_TEXT);
    }, CHECKOUT_PROGRESS_MS);

    // A slow GoKwik SDK can drop the first start call; when it finishes loading mid-attempt, start once more.
    var checkoutStarted = false;
    var checkoutRetriggered = false;
    var deadlineExtended = false;
    function retriggerWhenGoKwikLoads() {
      if (attemptId !== activeAttempt) return;
      // GoKwik is loading right now: give the SDK up to CHECKOUT_MAX_WAIT_MS before falling back.
      if (!deadlineExtended) {
        deadlineExtended = true;
        armDeadline(Math.max(0, CHECKOUT_MAX_WAIT_MS - (Date.now() - attemptStartedAt)));
      }
      if (!checkoutStarted || checkoutRetriggered) return;
      window.setTimeout(function () {
        if (checkoutRetriggered || attemptId !== activeAttempt || getVisibleGokwikFrame()) return;
        var restartCheckout = getCheckoutStarter();
        if (!restartCheckout) return;
        checkoutRetriggered = true;
        armDeadline(Math.max(CHECKOUT_RETRIGGER_WAIT_MS, CHECKOUT_MAX_WAIT_MS - (Date.now() - attemptStartedAt)));
        bindModalClose();
        try {
          restartCheckout();
        } catch (restartError) {
          console.warn('[GoKwik] Checkout restart failed.', restartError);
        }
      }, 400);
    }
    window.addEventListener('gokwikLoaded', retriggerWhenGoKwikLoads);

    try {
      if (bundleCartSettling) {
        await waitForStep(waitForBundleCartToSettle(attemptId));
        if (attemptId !== activeAttempt) return;
        invalidateCartCache();
      }

      if (pendingCartMutations) {
        var synced = await waitForStep(window.CartController.flushPendingCartMutations());
        if (attemptId !== activeAttempt) return;
        if (!synced) {
          setRetryState('Your cart is still updating. Please try again.');
          checkoutFeedback.hide();
          return;
        }
        invalidateCartCache();
      }

      if (isSyncing) {
        setCheckoutState('opening');
        checkoutFeedback.update('Opening secure checkout…');
      }

      var cart = await waitForStep(readConfirmedCart(attemptId));
      if (attemptId !== activeAttempt) return;
      if (!cart) throw new Error('Unable to confirm the current cart.');
      await waitForStep(prepareStandardCheckoutCart(cart, attemptId));
      if (attemptId !== activeAttempt) return;

      wakeGoKwik();
      var startCheckout = await waitForStep(waitForCheckoutStarter(attemptId));
      if (attemptId !== activeAttempt) return;
      if (!startCheckout) {
        setRetryState('Secure checkout could not load. Please check your connection and try again.');
        checkoutFeedback.hide();
        return;
      }

      bindModalClose();
      checkoutStarted = true;
      startCheckout();

      var frame = await waitForStep(waitForVisibleGokwikFrame(attemptId, CHECKOUT_MAX_WAIT_MS));
      if (attemptId !== activeAttempt) return;
      if (!frame) {
        setRetryState('Secure checkout is taking too long to open. Please try again.');
        checkoutFeedback.hide();
        return;
      }

      setCheckoutState('opened');
      checkoutFeedback.hide();
      focusCheckoutFrame(frame);
    } catch (error) {
      if (attemptId !== activeAttempt) return;
      activeAttempt += 1;
      invalidateCartCache();
      if (error.checkoutTimedOut) {
        setRetryState('Secure checkout is taking too long to open. Please try again.');
      } else {
        setRetryState('We couldn’t confirm your cart. Please try again.');
      }
      checkoutFeedback.hide();
      console.warn('[GoKwik] Checkout failed before opening.', error);
    } finally {
      window.clearTimeout(deadlineTimer);
      window.clearTimeout(progressTimer);
      window.removeEventListener('gokwikLoaded', retriggerWhenGoKwikLoads);
    }
  };

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.dtGokwikCheckoutClick(button).catch(function (error) {
      setRetryState();
      getCheckoutFeedback().hide();
      console.warn('[GoKwik] Checkout click failed.', error);
    });
  }, true);

  document.addEventListener('cart:updated', function (event) {
    invalidateCartCache();
    warmCheckout(event);
  }, { passive: true });
  document.addEventListener('dt:cart-intent', warmCheckout, { passive: true });
  document.addEventListener('cart-drawer:opening', warmCheckout, { passive: true });
  document.addEventListener('cart-drawer:opened', warmCheckout, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    initializeCheckoutButtons(document);
  });
  window.addEventListener('gokwikLoaded', bindModalClose);
  document.addEventListener('click', function (event) {
    if (!isBundleAddControl(event.target)) return;
    bundleCartActivity.intentAt = Date.now();
    bundleCartActivity.addSeenSinceIntent = false;
  }, true);
  observeBundleCartRequests();

  checkoutState = 'ready';
  initializeCheckoutButtons(document);
  bindModalClose();
})();
